import { AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContextImpl.mjs';
import { Key_instance2ye2t23iqghop as Key_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineExceptionHandler.mjs';
import { Companion_getInstancec4l82qvpwbuq as Companion_getInstance } from './coreInterfaces.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { Dispatchers_getInstanceitgtkvqfcnx3 as Dispatchers_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { CoroutineScopelux7s7zphw7e as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_AppJob() {
  _init_properties_AppScope_kt__e9fb1p();
  return AppJob;
}
var AppJob;
function get_AppScope() {
  _init_properties_AppScope_kt__e9fb1p();
  return AppScope;
}
var AppScope;
var AppScope$$inlined$CoroutineExceptionHandler$1Class;
function AppScope$$inlined$CoroutineExceptionHandler$1() {
  if (AppScope$$inlined$CoroutineExceptionHandler$1Class === VOID) {
    class $ extends AbstractCoroutineContextElement() {
      constructor() {
        super(Key_instance);
      }
      wa8(context, exception) {
        Companion_getInstance().xaj_1(exception);
        return Unit_instance;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [AbstractCoroutineContextElement(), Element()]);
    AppScope$$inlined$CoroutineExceptionHandler$1Class = $;
  }
  return AppScope$$inlined$CoroutineExceptionHandler$1Class;
}
var properties_initialized_AppScope_kt_9z3ewb;
function _init_properties_AppScope_kt__e9fb1p() {
  if (!properties_initialized_AppScope_kt_9z3ewb) {
    properties_initialized_AppScope_kt_9z3ewb = true;
    AppJob = SupervisorJob();
    var tmp = get_AppJob();
    // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
    var tmp$ret$0 = new (AppScope$$inlined$CoroutineExceptionHandler$1())();
    AppScope = CoroutineScope(tmp.gp(tmp$ret$0).gp(Dispatchers_getInstance().zac().tac()));
  }
}
//region block: exports
export {
  get_AppScope as get_AppScopes4bqeg21n0qw,
};
//endregion

//# sourceMappingURL=AppScope.mjs.map
